<div class="users-container">
  <app-header-actions [headerTitle]="'USERS.TITLE'" [headerIcon]="faUsers" [config]="{
      addButton: {
        type: 'add',
        text: 'BUTTON.CREATE',
        icon: faPlus,
        visible: true,
        disabled: false
      },
      showBackButton: true,
      searchConfig: {
        showTextSearch: true,
        showTagFilter: false,
        textPlaceholder: 'SEARCH.PLACEHOLDER.USERS',
        tagPlaceholder: ''
      }
    }" [count]="filteredUsers.length + ' ' + ('USERS.TITLE' | translate)" [showCount]="true"
    (addClick)="openCreateModal()" (backClick)="goBack()"
    (filtersChanged)="onHeaderSearch($event)"></app-header-actions>

  <div class="content-area">
    <app-item-list [items]="itemsForList" [loading]="loading" [config]="listConfig"
      [hasActiveFilters]="hasActiveFilters" (itemClick)="onItemClick($event)" (actionClick)="onActionClick($event)">
    </app-item-list>
  </div>
</div>

@if (showCreateModal || showEditModal) {
<div class="modal-overlay" (click)="closeModals()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <fa-icon [icon]="faUser"></fa-icon>
        <span>{{ showCreateModal ? ('USERS.CREATE_TITLE' | translate) : ('USERS.EDIT_TITLE' | translate) }}</span>
      </h3>
      <button class="close-btn" (click)="closeModals()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <form (ngSubmit)="showCreateModal ? createUser() : updateUser()">
        @if (showCreateModal || !isSimpleEdit) {
        <div class="form-group">
          <label>{{ 'USERS.FORM.USERNAME' | translate }}</label>
          <input type="text" [(ngModel)]="userForm.username" name="username"
            [placeholder]="'USERS.FORM.USERNAME.PLACEHOLDER' | translate" (input)="onUsernameChange()"
            [class.error]="nameError" required maxlength="50">
          @if (nameError) {
          <div class="error-message">
            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
            <span>{{ nameError }}</span>
          </div>
          }
        </div>
        <div class="form-group">
          <label>{{ 'USERS.FORM.EMAIL' | translate }}</label>
          <input type="email" [(ngModel)]="userForm.email" name="email"
            [placeholder]="'USERS.FORM.EMAIL.PLACEHOLDER' | translate" (input)="onEmailChange()"
            [class.error]="emailError" required>
          @if (emailError) {
          <div class="error-message">
            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
            <span>{{ emailError }}</span>
          </div>
          }
        </div>
        <div class="form-group">
          <label>{{ 'USERS.FORM.ROLE' | translate }}</label>
          <ng-select [(ngModel)]="userForm.role" name="role" [items]="availableRoles" bindLabel="labelKey"
            bindValue="value" [placeholder]="'USERS.FORM.ROLE.PLACEHOLDER' | translate"
            [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [clearable]="false" [searchable]="true" required>
            <ng-template ng-option-tmp let-item="item">
              {{ item.labelKey | translate }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ item.labelKey | translate }}
            </ng-template>
          </ng-select>
        </div>
        <div class="form-group">
          <label>{{ 'USERS.FORM.PASSWORD' | translate }}</label>
          <div class="password-input-wrapper">
            <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="userForm.password" name="password"
              [placeholder]="'USERS.FORM.PASSWORD.PLACEHOLDER' | translate" required minlength="6">
            <button type="button" class="password-toggle" (click)="togglePasswordVisibility()"
              [title]="showPassword ? ('USERS.HIDE_PASSWORD' | translate) : ('USERS.SHOW_PASSWORD' | translate)">
              <fa-icon [icon]="showPassword ? faEyeSlash : faEye"></fa-icon>
            </button>
          </div>
        </div>
        } @else {
        <div class="form-group">
          <label>{{ 'USERS.FORM.ROLE' | translate }}</label>
          <ng-select [(ngModel)]="userForm.role" name="role_simple" [items]="availableRoles" bindLabel="labelKey"
            bindValue="value" [placeholder]="'USERS.FORM.ROLE.PLACEHOLDER' | translate"
            [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [clearable]="false" [searchable]="true" required>
            <ng-template ng-option-tmp let-item="item">
              {{ item.labelKey | translate }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ item.labelKey | translate }}
            </ng-template>
          </ng-select>
          <small class="hint">
            {{ 'USERS.EDIT_SIMPLE_HINT' | translate }}
          </small>
        </div>
        }
        <div class="form-actions">
          <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="closeModals()">
          </app-button>
          <app-button
            [text]="isSubmitting ? ('USERS.SAVING' | translate) : (showCreateModal ? ('BUTTON.CREATE' | translate) : ('BUTTON.SAVE' | translate))"
            variant="primary" [icon]="faCheck" [loading]="isSubmitting" [disabled]="!!(
                isSubmitting ||
                (showCreateModal || !isSimpleEdit
                  ? (nameError || emailError || !userForm.username.trim() || !userForm.email.trim() || !userForm.password.trim())
                  : (!userForm.role))
              )" (clicked)="showCreateModal ? createUser() : updateUser()">
          </app-button>
        </div>
      </form>
    </div>
  </div>
</div>
}

@if (showDeleteModal) {
<div class="modal-overlay" (click)="closeModals()">
  <div class="modal-content small" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <fa-icon [icon]="faTrash"></fa-icon>
        <span>{{ 'USERS.DELETE_TITLE' | translate }}</span>
      </h3>
      <button class="close-btn" (click)="closeModals()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <p>{{ 'USERS.DELETE_CONFIRMATION' | translate:{ name: selectedUser?.username } }}</p>
      <div class="user-preview-delete">
        <fa-icon [icon]="faUser"></fa-icon>
        <div class="user-info">
          <strong>{{ selectedUser?.username }}</strong>
          <small>{{ selectedUser?.email }}</small>
          <span class="role-badge">{{ ('USERS.' + (selectedUser?.role || '')) | translate }}</span>
        </div>
      </div>
      <div class="form-actions">
        <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="closeModals()">
        </app-button>
        <app-button [text]="'BUTTON.DELETE' | translate" variant="danger" [icon]="faTrash" (clicked)="deleteUser()">
        </app-button>
      </div>
    </div>
  </div>
</div>
}


<app-modal-user-configurations [show]="showConfigurationsModal" [userId]="selectedUser?.id || ''"
  [username]="selectedUser?.username || ''" (close)="closeConfigurationsModal()">
</app-modal-user-configurations>